import React, {useMemo, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {Box} from "@mui/material";

// global components
import {LoadingView} from "../../../../designSystem/components/LoadingView";
import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {Breadcrumb} from "../Breadcrumb";

// shared components
import {PostList} from "../../../../components/PostList";

// local components
import {NextLevelCategoryList} from "../NextLevelCategoryList";

import {filterPostByKeyword} from "../../model/filterPostByKeyword";
import {usePostList} from "../../hooks/usePostList";

export const PostListFeature = () => {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState<string>('');
  const {categoryId} = useParams();

  const {
    posts,
    categoryTree,
    breadCrumb,
    nextLevelCategories,
    isLoading,
  } = usePostList({ categoryId })

  const onClickBreadCrumb = (categoryId: string) => {
    if (categoryId) {
      navigate(`/infoList/c/${categoryId}`);
    } else {
      navigate('/infoList');
    }
  }

  const filteredPosts = useMemo(() => {
    return filterPostByKeyword(posts, keyword);
  }, [posts, keyword])

  if (isLoading)
    return <LoadingView />;

  return (
    <Box>
      {/* The filter bar */}
      <Box className="relative">
        <Box className="flex flex-row justify-evenly items-center gap-2 px-2 pt-2 pb-2 z-20 shadow-md">
          <BaseInput
            value={keyword}
            placeholder={"請輸入關鍵字"}
            onChange={(e) => {
              setKeyword(e.target.value)
            }}
          />
        </Box>
      </Box>

      {/* The article list */}
      <Box className={"flex flex-1 flex-col overflow-y-scroll bg-gray-100"}>
        <div className={"p-3 pb-1 pt-4"}>
          <Breadcrumb
            items={breadCrumb}
            onNavigate={onClickBreadCrumb}
          />
        </div>
        <div className="flex">
          <NextLevelCategoryList
            categories={nextLevelCategories}
            onNavigate={onClickBreadCrumb}
          />
        </div>
        <PostList
          posts={filteredPosts}
          categories={categoryTree}
          onClickPost={p => navigate(`/infoList/p/${p.id}`)}
        />
      </Box>
    </Box>
  )
}